<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner bdColor="rgba(23, 1, 51, 0.9)" size="medium" color="#fff" type="ball-fussion" [fullScreen]="true">
        <p style="color: white"> Please Wait... </p>
    </ngx-spinner>
</div>

<div class="container bradcum-max-width">
    <div class="row py-2 d-flex justify-content-center">
      <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
        <ol class="breadcrumb m-0">
          <li class="breadcrumb-item"><a href="#">Business NSW</a></li>
       <li class="breadcrumb-item">Events</li>
          <!-- <li class="breadcrumb-item"><a href="#">Upcoming Events</a></li>
          <li class="breadcrumb-item" aria-current="page">{{commonService.breadcrumb}}</li>
          <li class="breadcrumb-item" aria-current="">registration</li> --> 
        </ol>
      </nav>
    </div>
  </div>


<!-- <div class="hidden sm:flex items-center font-medium">
    <div>
        <a class="whitespace-nowrap text-primary dark:text-yellow-300 flex truncate"
            [routerLink]="'#'">&nbsp;&nbsp;<mat-icon class="icon-size-5 text-primary dark:text-yellow-300"
               >
            </mat-icon>
            &nbsp;</a>
    </div>
    <div class="flex items-center ml-1 whitespace-nowrap">
        <mat-icon class="icon-size-5 text-primary dark:text-yellow-300" >
        </mat-icon>
        <a class="ml-1 text- text-primary dark:text-yellow-300" [routerLink]="">Events
        </a>
    </div>
    <div>
        <a class="whitespace-nowrap text-primary dark:text-yellow-300 flex truncate" [routerLink]="['#']">&nbsp;&nbsp;
            <mat-icon class="icon-size-5 text-primary dark:text-yellow-300" >
            </mat-icon>
            &nbsp;
        </a>
    </div>
</div> -->

<div>
    <img class="homeImg" src="../../assets/images/homeImg1.png">
</div>

<div style="background-color: black;">
    <div class="container">
        <div class="row d-flex justify-content-center py-3" *ngIf="eventTypes?.length">
            <div *ngFor="let types of eventTypes" class="col-md-2 text-center">
                <button (click)="setActiveEventType(types.name)" mat-fab class="btnIcone "
                    [class.active]="types.name === activeEventType"><mat-icon class="maticon"
                        style="font-size: 50px;">{{types.iconName}}</mat-icon></button>
                <br>
                <br>
                <div>
                    <b>{{types.Type}}</b>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container bradcum-max-width">
    <div class="row p-4 d-flex"  *ngIf="eventDetails?.length">
        <div class="card p-2 m-2 col-md-3 cardHeight" style="width: 21rem;" *ngFor="let details of eventDetails">
            <img *ngIf="details.eventImageUrl" src="{{details.eventImageUrl}}"
                class="rounded shadow-lg photo-icon1" alt="...">
            <img *ngIf="!details.eventImageUrl " class="photo-icon1 rounded shadow-lg"
            src="../../assets/events/eventImg2.jpg">
            <div class="flex actions">
                <button class="card shadow mx-1.5" (click)="addToWishlist(details)">
                    <mat-icon class="material-icons-outline fs-5 lh-sm"
                        [ngStyle]="{'color': details.isInWishlist ? 'red' : 'gray'}">favorite</mat-icon>
                </button>
                <!-- <button class="card shadow">
                    <mat-icon class="material-icons-outlined fs-5 lh-sm">share</mat-icon>
                </button> -->
            </div>
            <div class="card-body">
                <p class="fw-bold textDot">{{details.eventName}}</p>
                <p class="fw-fw-bolder textDot">{{details.eventLocation}}</p>
                <br *ngIf="!details.eventLocation">
                <p class="fw-fw-bolder textDot">{{details.eventStartDateTime | date }}</p>
                <button class="rounded-xl btn btn-primary btn-lg" (click)="showMoreDetails(details.eventId)">Event
                    Details</button>
            </div>
        </div>
    </div>
</div>